import { UseQueryResult } from "@tanstack/react-query";
import { useGetQuery, UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

const facilitiesResponseSchema = z.array(
  z.object({
    userId: z.string(),
    name: z.string(),
  })
);

type FacilitiesResponse = z.infer<typeof facilitiesResponseSchema>;

export function useGetFacilities(
  filter: Record<string, string | number>,
  options: UseGetQueryOptions<FacilitiesResponse> = {}
): UseQueryResult<FacilitiesResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/facilityprofile/list`,
    queryParams: filter,
    responseSchema: facilitiesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITIES,
    },
    refetchOnWindowFocus: false,
    ...options,
  });
}
